<div class="flex items-center" mat-dialog-title>
  <h2 class="headline m-0 flex-auto">Ajouter des membres à {{ data.team.name }}</h2>
  <button mat-icon-button type="button" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-divider class="-mx-6"></mat-divider>

<mat-dialog-content class="pt-4 flex flex-col gap-2">
  <p class="m-0 mb-2 caption text-secondary flex items-center gap-2">
    Rôle {{ data.team.role }} et au moins une affectation parmi : {{ perimeter }}
    <mat-icon
      class="text-hint"
      style="font-size: 16px; width: 16px; height: 16px"
      matTooltip="Pour entrer dans l'équipe, il faut avoir son rôle et être affecté à au moins un établissement client de son établissement support."
    >
      info
    </mat-icon>
  </p>
  <div
    *ngFor="let candidate of candidates"
    class="flex items-center gap-3 rounded px-2 py-2"
    [ngClass]="{ 'opacity-50': candidate.issue }"
  >
    <mat-checkbox color="primary" [disabled]="!!candidate.issue" [(ngModel)]="candidate.selected"></mat-checkbox>
    <div class="flex-auto min-w-0">
      <p class="m-0 body-1">{{ candidate.person.fullName }}</p>
      <p class="m-0 caption text-secondary truncate">
        {{ candidate.person.roles.join(', ') }} · {{ candidate.establishments }}
      </p>
    </div>
    <span *ngIf="candidate.issue" class="caption text-warn text-right">{{ candidate.issue }}</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">ANNULER</button>
  <button mat-raised-button color="primary" type="button" (click)="close()">AJOUTER</button>
</mat-dialog-actions>
